<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners || showLegend}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label">
					<span class="cursor-pointer underline zt-hover whitespace-nowrap min-w-[18px] pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer underline zt-hover truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
				</div>
        <div class="flex">
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'avgCornersPlus' }"
               @click="sortTable('avgCornersPlus', $event)"><div>Śr+</div></div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'avgCornersMinus' }"
               @click="sortTable('avgCornersMinus', $event)"><div>Śr-</div></div>
          <div class="foot-tab-row-item !w-[50px]"
               :class="{ '!no-underline' : sortColumn === 'avgCorners' }"
               @click="sortTable('avgCorners', $event)"><div>ŚR</div></div>
        </div>
			</div>
      <template v-for="(team, index) in leagueTable" :key="team.team_id">
        <div class="foot-tab-row last:!border-b-0 last:!rounded-b-zt"
             v-if="avgCornersPlus(team) > 0"
             :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id) }" >
          <div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
            <p class="flex items-center">
              <span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
              <a v-if="(!selectedTeamsIds.includes(+team.team_id) || selectedTeamsIds.length !== 1)"
                 :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
                 class="no-default-style" :class="{ 'zt-hover': team.clickable }">
                <span class="flex items-center mr-2 aspect-square h-5">
                  <TeamImg :team="team"/>
                </span>
              </a>
              <span v-else class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
              <a v-if="!selectedTeamsIds.includes(+team.team_id)"
                 class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
                 :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
                {{ team.short_name?.length > 0 ? team.short_name : team.name }}
              </a>
              <span v-else class="text-ellipsis line-clamp-1 break-all">
                {{ team.short_name?.length > 0 ? team.short_name : team.name }}
              </span>
            </p>
          </div>
          <transition appear name="fade" mode="out-in">
            <div :key="filterKey" class="flex font-['Lato']">
              <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'avgCornersPlus' }">
                <div>{{ avgCornersPlus(team) }}</div>
              </div>
              <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'avgCornersMinus' }">
                <div>{{ avgCornersMinus(team) }}</div>
              </div>
              <div class="foot-tab-row-item !w-[50px]" :class="{ 'foot-tab-row-item-active' : sortColumn === 'avgCorners' }">
                <div>{{ (+avgCornersPlus(team) + +avgCornersMinus(team)).toFixed(1) }}</div>
              </div>
            </div>
          </transition>
        </div>
      </template>
		</div>
    <div v-if="showLegend" class="pl-4 py-3 bg-zt-light/35 rounded-b-zt border-[1px] border-t-[0px] border-zt-light">
      <div class="legend grid grid-cols-4 duration-500 legend-full max-h-[250px] xl:max-h-[180px] opacity-100">
        <div class="col-span-4 text-zt-more text-[10px] -ml-2">
          <div>ŚR+ to średnia rożnych otrzymanych</div>
          <div>ŚR- to średnia rożnych pod ich bramką</div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'CornersTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    },
    showLegend: {
      type: Boolean,
      default: false
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'avgCorners',
			sortAscending: 0,
			currentSubTab: this.filters[1] ?? 'all',
			cornerStatus: 'all',
			corners: 'result',
			displayedTable: 'all',
			isLpSet: false,
			overunder: 0.5,
			teamsSorted: [],
		}
	},
	mounted() {
		this.teamsSorted = this.teams;
		this.teamsSorted.sort(this.sortTeams).forEach((team, i) => { team.currentTablePosition = i + 1; });
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[1];
				this.leagueTable.forEach((team, i) => {team.currentTablePosition = i+1;});
			}, 200);
		}
	},
	methods: {
		avgCornersPlus(team) {
			let allMatches = this.allMatchesWithCorners(team);
      let matchesWithoutCorners = this.allMatchesWithoutCorners(team);
      let allCorners = this.allCorners(team);
      if (allMatches > 0) {
        if (matchesWithoutCorners === 0) {
          return (allCorners/allMatches).toFixed(1);
        } else {
          allCorners += (allCorners / (allMatches - matchesWithoutCorners)) * matchesWithoutCorners
          return (allCorners / allMatches).toFixed(1);
        }
      }
      return 0;
		},
		avgCornersMinus(team) {
      let allMatches = this.allMatchesWithCorners(team);
      let matchesWithoutCorners = this.allMatchesWithoutCorners(team);
      let allCorners = this.allCornersAgainst(team);
      if (allMatches > 0) {
        if (matchesWithoutCorners === 0) {
          return (allCorners/allMatches).toFixed(1);
        } else {
          allCorners += (allCorners / (allMatches - matchesWithoutCorners)) * matchesWithoutCorners
          return (allCorners / allMatches).toFixed(1);
        }
      }
      return 0;
		},
		avgCorners(team) {
			let allMatches = this.allMatchesWithCorners(team);
      let matchesWithoutCorners = this.allMatchesWithoutCorners(team);
			if (allMatches > 0) {
				let allCorners = this.getTeamMatches(team).reduce((sum, match) => {
					return sum + parseInt(match.localteam_stats.corners) + parseInt(match.visitorteam_stats.corners);
				}, 0);
        if (matchesWithoutCorners === 0) {
          return (allCorners/allMatches).toFixed(1);
        } else {
          allCorners += (allCorners / (allMatches - matchesWithoutCorners)) * matchesWithoutCorners
          return (allCorners / allMatches).toFixed(1);
        }
			} else {
				return 0;
			}
		},
		allCorners(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.localteam_stats.corners);
					} else if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.visitorteam_stats.corners);
					}
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.localteam_stats.corners);
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.visitorteam_stats.corners);
					} else {
						return sum;
					}
				}, 0);
		},
		allCornersAgainst(team) {
			if (this.currentSubTab === 'all')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id)
						return sum + parseInt(match.visitorteam_stats.corners);
					else if (match.visitorteam_id === team.team_id)
						return sum + parseInt(match.localteam_stats.corners);
				}, 0);
			else if (this.currentSubTab === 'home')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						return sum + parseInt(match.visitorteam_stats.corners);
					} else {
						return sum;
					}
				}, 0);
			else if (this.currentSubTab === 'away')
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.visitorteam_id === team.team_id) {
						return sum + parseInt(match.localteam_stats.corners);
					} else {
						return sum;
					}
				}, 0);
		},
		sortTeams(a, b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'avgCornersPlus':
					if (this.sortAscending) {
						diff = this.avgCornersPlus(a) - this.avgCornersPlus(b);
					} else {
						diff = this.avgCornersPlus(b) - this.avgCornersPlus(a);
					}
					break;
				case 'avgCornersMinus':
					if (this.sortAscending) {
						diff = this.avgCornersMinus(a) - this.avgCornersMinus(b);
					} else {
						diff = this.avgCornersMinus(b) - this.avgCornersMinus(a);
					}
					break;
				case 'avgCorners':
					if (this.sortAscending) {
						diff = this.avgCorners(a) - this.avgCorners(b);
					} else {
						diff = this.avgCorners(b) - this.avgCorners(a);
					}
					break;
				case 'corners':
					if (this.sortAscending) {
						diff = this.allCorners(a) - this.allCorners(b);
					} else {
						diff = this.allCorners(b) - this.allCorners(a);
					}
					break;
				case 'position':
					if (this.sortAscending) {
						diff = a.currentTablePosition - b.currentTablePosition;
					} else {
						diff = b.currentTablePosition - a.currentTablePosition;
					}
					break;
				default:
					diff = this.allCorners(b) - this.allCorners(a);
					if (diff === 0) {
						diff = this.getPoints(b) - this.getPoints(a);
					}
			}
			return diff;
		}
	}

}

</script>

<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>